import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { ChevronLeft, Settings, Plus, Mail } from 'lucide-react';

const AdminHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine page-specific content
  const getPageConfig = () => {
    const path = location.pathname;
    
    if (path === '/admin/emails') {
      return {
        title: 'Email Management',
        backTo: '/admin',
        backLabel: 'Admin Dashboard',
        actions: [
          {
            label: 'Rules',
            icon: Settings,
            onClick: () => navigate('/admin/email-rules'),
            variant: 'outline',
            className: 'border-purple-500/20 text-purple-400 hover:bg-purple-500/10'
          },
          {
            label: 'Compose',
            icon: Plus,
            onClick: () => {}, // Will be handled by parent component
            variant: 'default',
            className: 'bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700',
            id: 'compose-btn'
          }
        ]
      };
    }
    
    if (path === '/admin/email-rules') {
      return {
        title: 'Email Rules',
        backTo: '/admin/emails',
        backLabel: 'Back to Emails',
        actions: [
          {
            label: 'Create Rule',
            icon: Plus,
            onClick: () => {}, // Will be handled by parent component
            variant: 'default',
            className: 'bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700',
            id: 'create-rule-btn'
          }
        ]
      };
    }
    
    if (path === '/admin/licenses') {
      return {
        title: 'License Management',
        backTo: '/admin',
        backLabel: 'Admin Dashboard',
        actions: [
          {
            label: 'Create License',
            icon: Plus,
            onClick: () => navigate('/admin/licenses/create'),
            variant: 'default',
            className: 'bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700'
          }
        ]
      };
    }

    if (path === '/admin/licenses/create') {
      return {
        title: 'Create License',
        backTo: '/admin/licenses',
        backLabel: 'Back to Licenses',
        actions: []
      };
    }
    
    if (path === '/admin/users') {
      return {
        title: 'User Management',
        backTo: '/admin',
        backLabel: 'Admin Dashboard',
        actions: []
      };
    }
    
    // Default for admin dashboard
    return {
      title: 'Admin Dashboard',
      backTo: '/dashboard',
      backLabel: 'User Dashboard',
      actions: []
    };
  };

  const config = getPageConfig();

  return (
    <div className="flex-none bg-gray-900/50 border-b border-purple-500/20 backdrop-blur-xl w-full">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between">
          {/* Left side - Back button and title */}
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              onClick={() => navigate(config.backTo)}
              className="text-gray-400 hover:text-white"
            >
              <ChevronLeft className="h-5 w-5 mr-1" />
              {config.backLabel}
            </Button>
            <h1 className="text-xl sm:text-2xl font-bold text-white hidden sm:block">
              {config.title}
            </h1>
          </div>

          {/* Right side - Action buttons */}
          {config.actions.length > 0 && (
            <div className="flex items-center gap-2">
              {config.actions.map((action, index) => {
                const Icon = action.icon;
                return (
                  <Button
                    key={index}
                    id={action.id}
                    variant={action.variant}
                    onClick={action.onClick}
                    className={action.className}
                  >
                    <Icon className="h-4 w-4 mr-2" />
                    {action.label}
                  </Button>
                );
              })}
            </div>
          )}
        </div>
        
        {/* Mobile title - shows below on small screens */}
        <h1 className="text-lg font-bold text-white mt-2 sm:hidden">
          {config.title}
        </h1>
      </div>
    </div>
  );
};

export default AdminHeader;

